import { ReactNode } from 'react';
import { EmptyField } from 'components/elements/EmptyField';
import { Label } from 'components/elements/Label';
import { Text } from 'components/elements/Text';
import { InfoModal } from 'components/widgets/InfoModal';
import { useGetModalActions } from 'hooks/useModal';
import { STATE_CODE_TO_LABEL } from 'utils/constants/location';

const addressText = {
  textTransform: 'capitalize',
};

const MetadataRow = ({
  label,
  children,
  hideDivider,
}: {
  label: string;
  children: ReactNode;
  hideDivider?: boolean;
}) => (
  <InfoModal.Row hideDivider={hideDivider}>
    <Label>{label}</Label>
    <InfoModal.RowDetails>{children}</InfoModal.RowDetails>
  </InfoModal.Row>
);

type MasterDocumentModalProps = {
  address: string;
  city: string;
  state_code: string;
  isLoading: boolean;
};

const MasterDocumentModal = ({
  address,
  city,
  state_code,
  isLoading,
}: MasterDocumentModalProps) => {
  const { Skeleton } = useGetModalActions(isLoading);

  return (
    <>
      <MetadataRow label="Address" hideDivider>
        <Skeleton variant="text" noOfLines={1}>
          {address ? <Text sx={addressText}>{address}</Text> : <EmptyField />}
        </Skeleton>
      </MetadataRow>
      <MetadataRow label="City" hideDivider>
        <Skeleton variant="text" noOfLines={1}>
          {city ? <Text>{city}</Text> : <EmptyField />}
        </Skeleton>
      </MetadataRow>
      <MetadataRow label="State" hideDivider>
        <Skeleton variant="text" noOfLines={1}>
          {state_code ? <Text>{STATE_CODE_TO_LABEL[state_code]}</Text> : <EmptyField />}
        </Skeleton>
      </MetadataRow>
    </>
  );
};

export default MasterDocumentModal;
